import { generatePath } from 'react-router-dom'
import { CompanyTag } from '@/components/ui/badge'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { TradingAccountSearchResultDto } from 'api/Search/Types/SearchResultDto'
import { Link } from 'components/Link'
import { generateRoutePathByAccountGroupType } from 'helpers/trading-accounts'
import { links } from 'utils/featureToggles'

import { TradingAccountStatusIcon } from './SearchStatusIcon'

export const TradingAccountColumnDefinition: GridColumnProps[] = [
  {
    title: 'Name',
    cell: (props: GridCellProps): JSX.Element => {
      const data = props.dataItem as TradingAccountSearchResultDto
      if (!data.value) {
        return <td />
      }
      if (!data?.id) {
        return <td />
      }

      return (
        <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
          <Link
            to={{
              pathname: generateRoutePathByAccountGroupType(data.data.accountGroupType.id, data.id),
            }}
          >
            {data.value}
          </Link>
        </td>
      )
    },
  },
  {
    title: 'Introducing Broker',
    cell: (props: GridCellProps): JSX.Element => {
      const data = props.dataItem as TradingAccountSearchResultDto
      if (!data.data?.introducingBroker?.name) {
        return <td />
      }
      return (
        <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
          <Link
            to={{
              pathname: generatePath(links.recordsIntroducingBrokers.detailsUrl as string, {
                id: data.data.introducingBroker.id,
                slug: 'details',
              }),
            }}
          >
            {data.data.introducingBroker.name}
          </Link>
        </td>
      )
    },
  },
  {
    title: 'Account Group',
    cell: (props: GridCellProps): JSX.Element => {
      const data = props.dataItem as TradingAccountSearchResultDto
      if (!data.data?.accountGroup?.name) {
        return <td />
      }
      return (
        <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
          <Link
            to={{
              pathname: generatePath(links.recordsAccountGroups.detailsUrl as string, {
                id: data.data.accountGroup.id,
                slug: 'details',
              }),
            }}
          >
            {data.data.accountGroup.name}
          </Link>
        </td>
      )
    },
  },
  {
    title: 'Status',
    cell: (props: GridCellProps): JSX.Element => {
      const statusId = props.dataItem?.data?.status?.id
      const data = props.dataItem as TradingAccountSearchResultDto
      if (!data?.data?.status?.name) {
        return <td />
      }
      return (
        <td>
          <span>
            {data.data.status.name} <TradingAccountStatusIcon statusId={statusId} />{' '}
          </span>
        </td>
      )
    },
  },
  {
    title: 'Entity',
    cell: (props: GridCellProps): JSX.Element => {
      const data = props.dataItem as TradingAccountSearchResultDto
      if (!data.data?.tickmillCompany?.id) {
        return <td />
      }
      return (
        <td>
          <CompanyTag id={data.data.tickmillCompany.id}>
            {data.data.tickmillCompany.name}
          </CompanyTag>
        </td>
      )
    },
    width: 80,
    minResizableWidth: 80,
  },
]
